export default __webpack_public_path__ + "fonts/demographics_income_icon.svg";